import React from "react";
import { useIntl } from "react-intl";
import { commonMessages } from "../../utils/messages";

import "./RequiredInputLabelMarker.scss";

// Reference: https://a11y-101.com/development/required

const RequiredInputLabelMarker = () => {
    const intl = useIntl();

    return (
        <i
            aria-hidden
            className="required-input-label-marker"
            title={intl.formatMessage(commonMessages.required)}
        />
    );
};
export default RequiredInputLabelMarker;
